import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-upload\"><path d=\"M64 8 L120 64 L80 64 L80 120 L48 120 L48 64 L8 64 Z\" fill=\"#909399\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol